import { render, staticRenderFns } from "./ClientPricingList.vue?vue&type=template&id=0857ac31&scoped=true&"
import script from "./ClientPricingList.vue?vue&type=script&lang=js&"
export * from "./ClientPricingList.vue?vue&type=script&lang=js&"
import style0 from "./ClientPricingList.vue?vue&type=style&index=0&id=0857ac31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0857ac31",
  null
  
)

export default component.exports